import { CONFIG } from '../../../config/mainConfig';
import { CouponTypesEnum } from '../../../interfaces/coupon.interface';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { PlanDetailsModel } from '../../../interfaces/plan.interface';
import { callAPI } from '../../../services/api.service';
import { Toast } from '../Toast';

export const applyPromoCodeService = async (
  couponCode: string | null,
  selectedPlanDescription: PlanDetailsModel | null,
  setCouponClass: (value: string) => void,
  setCouponDescription: (value: string | null) => void,
  setCouponDiscount: (value: any) => void,
  setPrice: (value: string | null) => void,
  setCouponCode: (value: string | null) => void,
  setCouponLoader: (value: boolean) => void
) => {
  setCouponLoader(true);

  try {
    const response = await callAPI('user/coupon-validate', {
      couponCode,
      amount: selectedPlanDescription?.cost,
      requestType: CouponTypesEnum.FOR_PLAN_PURCHASE,
    });

    if (response?.status === HTTPStatusEnum.OK) {
      setCouponClass('text-storygreen');
      const discountedPrice = parseFloat(response?.data?.discount).toFixed(2);
      setCouponDescription(response?.data?.couponDescription);
      setCouponDiscount(Number(discountedPrice));
      setPrice(parseFloat(response?.data?.price).toFixed(2));
      setCouponCode(couponCode);
      Toast('Coupon Applied');
    } else {
      setCouponClass('text-storyred');
      if (response?.data?.couponCode?.startsWith('GC')) {
        Toast('Invalid Gift Card', true);
      } else {
        Toast('Invalid Coupon', true);
      }
    }
  } catch (error) {
    Toast('Error applying promo code', true);
  } finally {
    setCouponLoader(false);
  }
};
